export function isMediaLoaded(media) {
  return media instanceof HTMLImageElement && media.complete || media instanceof HTMLVideoElement && media.readyState >= 3;
}